export default {
	scrollBehavior() {
		return { top: 0 };
	},
};
